import React, { Component } from "react";
import Modal from "react-modal";
import "../../../src/styles/levelOneWelcomeModal.scss";

//Avatars
import koala from "../images/koala.png";
import fox from "../images/fox.png";
import lemur from "../images/lemur.png";
import zebra from "../images/zebra.png";

export default class WelcomeModal extends Component {
  constructor() {
    super();

    this.state = {
      modalIsOpen: true
    };

    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal() {
    this.setState({ modalIsOpen: true });
  }

  closeModal() {
    this.setState({ modalIsOpen: false });
  }

  render() {
    return (
      <div>
        <Modal
          className="Modal card"
          isOpen={this.state.modalIsOpen}
          onRequestClose={this.closeModal}
          shouldFocusAfterRender={false}
          shouldCloseOnOverlayClick={false}
          shouldCloseOnEsc={false}
          contentLabel="Example Modal"
        >
          <div className="Welcome-modal-container">
            <h2>
              Hi&nbsp;
              <span style={{ color: "#52b452" }}>{this.props.username}</span>!
            </h2>
            <img
              src={
                localStorage.getItem("avatar") === "Koala"
                  ? koala
                  : localStorage.getItem("avatar") === "Fox"
                  ? fox
                  : localStorage.getItem("avatar") === "Lemur"
                  ? lemur
                  : localStorage.getItem("avatar") === "Zebra"
                  ? zebra
                  : koala
              }
              alt="Koala"
              width="40%"
              height="auto"
            />

            <p>
              I am <span style={{ fontWeight: 600 }}>Gira</span> and I will be
              your guide throughout the game. The game consists of{" "}
              <span style={{ fontWeight: 600 }}>
                3 rounds with 2 levels each
              </span>
              . <br />
              <br />
              If you are unsure about anything, or want to quit the game, just click the{" "}
              <span style={{ fontWeight: 600 }}>question mark</span> in the top
              right corner at any time!
            </p>

            <button
              className="cta-button"
              onClick={() => {
                this.closeModal();
                this.props.showUI();
              }}
            >
              Continue
            </button>
          </div>
        </Modal>
      </div>
    );
  }
}
